import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "@/components/ui/sonner";
import { useAuth } from "@/contexts/AuthContext";

// Oct 26 2026, the user's answer to "when an operator forgets his password":
// the admin resets it AND he can change it himself - this is the self-service
// half, for a floor login that knows its current password.
export const ChangePasswordDialog = ({ open, onOpenChange }) => {
  const { changePassword } = useAuth();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const close = (value) => {
    if (!value) { setCurrent(""); setNext(""); setError(""); }
    onOpenChange(value);
  };

  const submit = async () => {
    setBusy(true);
    setError("");
    try {
      await changePassword(current, next);
      toast.success("Your password is changed");
      close(false);
    } catch (e) {
      setError(e.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={close}>
      <DialogContent className="sm:max-w-sm" data-testid="change-password-dialog">
        <DialogHeader>
          <DialogTitle>Change your password</DialogTitle>
        </DialogHeader>
        <div className="space-y-2">
          <Input
            type="password" placeholder="Current password" value={current}
            onChange={(e) => setCurrent(e.target.value)} data-testid="dialog-current-password"
          />
          <Input
            type="password" placeholder="New password (6 characters or more)" value={next}
            onChange={(e) => setNext(e.target.value)} data-testid="dialog-new-password"
          />
          {error && <p className="text-xs text-red-700" data-testid="dialog-password-error">{error}</p>}
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => close(false)} data-testid="dialog-password-cancel">Cancel</Button>
          <Button
            className="bg-[#0E7C86] hover:bg-[#0B6B74]"
            disabled={busy || !current || next.length < 6}
            onClick={submit}
            data-testid="dialog-password-save"
          >
            {busy ? "Saving..." : "Save"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
